import { render, staticRenderFns } from "./main-section-edit-person.vue?vue&type=template&id=8b1564a6&scoped=true"
import script from "./main-section-edit-person.vue?vue&type=script&lang=js"
export * from "./main-section-edit-person.vue?vue&type=script&lang=js"
import style0 from "./main-section-edit-person.vue?vue&type=style&index=0&id=8b1564a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1564a6",
  null
  
)

export default component.exports